import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { 
    path: 'privacy-policy', 
    loadComponent: () => import('./pages/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
  },
  { 
    path: 'terms-use', 
    loadComponent: () => import('./pages/terms-use/terms-use.component').then(m => m.TermsUseComponent)
  },
  { 
    path: 'legal-notice', 
    loadComponent: () => import('./pages/legal-notice/legal-notice.component').then(m => m.LegalNoticeComponent)
  },
  { path: '**', redirectTo: '' }
];